var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_7164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3225 7.66161L7.66167 22.3224L6.91284 23.0712L13.7932 29.9516C14.1914 29.9833 14.5937 30 15.0001 30C23.2843 30 30.0001 23.2843 30.0001 15C30.0001 14.5937 29.9834 14.1913 29.9517 13.7931L23.0713 6.91272L22.3225 7.66161Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 15C3.57422 21.3103 8.68969 26.4258 15 26.4258L16.6344 15L15 3.57422C8.68969 3.57422 3.57422 8.68969 3.57422 15Z",
    fill: "#324380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4258 15C26.4258 8.68969 21.3103 3.57422 15 3.57422V26.4258C21.3103 26.4258 26.4258 21.3103 26.4258 15Z",
    fill: "#202C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03906 15C5.03906 20.5013 9.49875 24.9609 15 24.9609L16.4848 15L15 5.03906C9.49875 5.03906 5.03906 9.49875 5.03906 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9609 15C24.9609 9.49875 20.5013 5.03906 15 5.03906V24.9609C20.5013 24.9609 24.9609 20.5013 24.9609 15Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2711 18.7289C10.2414 17.6992 9.72656 16.3496 9.72656 15L8.19691 13.974L6.21094 15C6.21094 17.2493 7.06904 19.4987 8.7852 21.2148L11.2711 18.7289Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2711 11.2711L10.7619 9.456L8.7852 8.78516C7.06904 10.5013 6.21094 12.7507 6.21094 15H9.72656C9.72656 13.6504 10.2414 12.3008 11.2711 11.2711Z",
    fill: "#C1C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78516 8.7852L11.2711 11.2711C12.3008 10.2414 13.6504 9.72656 15 9.72656L16.1556 8.16949L15 6.21094C12.7507 6.21094 10.5013 7.06904 8.78516 8.7852Z",
    fill: "#A2A9B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2148 8.7852C19.4987 7.06904 17.2493 6.21094 15 6.21094V9.72656C16.3496 9.72656 17.6992 10.2414 18.7289 11.2711L20.524 10.7725L21.2148 8.7852Z",
    fill: "#5E72B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2149 8.78516L18.729 11.2711C19.7587 12.3008 20.2735 13.6504 20.2735 15L22.0202 15.6794L23.7892 15C23.7892 12.7507 22.9311 10.5013 21.2149 8.78516Z",
    fill: "#475A9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2149 21.2148C22.9311 19.4987 23.7892 17.2493 23.7892 15H20.2735C20.2735 16.3496 19.7587 17.6992 18.729 18.7289L21.2149 21.2148Z",
    fill: "#324380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5263 15.5263C15.9651 15.0876 15.917 14.3628 15.4241 13.9858L9.31152 9.31152L13.9858 15.4241C14.3628 15.917 15.0875 15.9651 15.5263 15.5263Z",
    fill: "#324380"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_7164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeights);
export default __webpack_public_path__ + "static/media/weights.071483252a522f87344a0011f6c91fad.svg";
export { ForwardRef as ReactComponent };